(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', '$stateParams', 'User', 'JhiLanguageService','AnagraficaService','$q'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, $$stateParams, User, JhiLanguageService,AnagraficaService,$q) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_GESTIONE_UTENTI','ROLE_SP_ADD','ROLE_SP_APPROVE'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.enableUser = enableUser;
        vm.disableUser = disableUser;
//        vm.user = entity;
        vm.aggiungiAlias = aggiungiAlias;
        vm.removeAlias = removeAlias;
        vm.mailAliases = [];
        vm.newAliasPosta = null;
        //vm.checkUniqueAlias = checkUniqueAlias;
        
        vm.enabled = null;
        
        
        AnagraficaService.strutturato.getOne({userId : $stateParams.userId},function(user){
        	vm.user = user;
        	if(vm.user.aliasPosta!=null && vm.user.aliasPosta.length>0){
            	vm.mailAliases = vm.user.aliasPosta.split(";");
            }

        });
        
        User.isEnabled({userId : $stateParams.userId},function(abilitatoDto){
        	vm.enabled = abilitatoDto.flAbilitato;
        });

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function enableUser() {
        	User.setEnabled({userId : $stateParams.userId, flAbilitato: true}, function(){ vm.enabled = true; });
        }
        
        function disableUser() {
        	User.setEnabled({userId : $stateParams.userId, flAbilitato: false}, function(){ vm.enabled = false; });
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if(vm.mailAliases!=null && vm.mailAliases.length>1)
            	vm.user.aliasPosta = vm.mailAliases.join(";");
            else if(vm.mailAliases!=null)
            	vm.user.aliasPosta = vm.mailAliases[0];
            AnagraficaService.strutturato.update(vm.user, onSaveSuccess, onSaveError);
            
            
//            if (vm.user.id !== null) {
//                User.update(vm.user, onSaveSuccess, onSaveError);
//            } else {
//                User.save(vm.user, onSaveSuccess, onSaveError);
//            }
        }
        
        function aggiungiAlias(){
        	if(vm.mailAliases.indexOf(vm.newAliasPosta)==-1)
        		vm.mailAliases.push(vm.newAliasPosta);
        	
        	vm.newAliasPosta = null;
        };
        function removeAlias(alias){
        	var index = vm.mailAliases.indexOf(alias);
        	if(index>-1)
        		vm.mailAliases.splice(index,1);
        }
        
        
        /*function checkUniqueAlias(alias) {
        	var isValid = false;
        	var deferred = $q.defer();
        	
        	if(alias==null || alias.length==0)
        		deferred.resolve(true);
        	else{
	        	AnagraficaService.checkUniqueAlias.check(alias, function(resp) {
	        		isValid = resp.isUnique;
	        		if(isValid) {
	        			deferred.resolve(isValid);
	        		}
	        		else {
	        			deferred.reject(false);
	        		}
	        	}, function(err) {
	        			deferred.reject(false);
	        	});
        	}
        	return deferred.promise;
        };*/
        
       
    }
})();
